import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { CnAsyncSelect } from '@alife/cn-ui';
import { getOwners, getItemCenterHost } from './utils';
function OwnerSelect(props) {
    const { params = {}, mode } = props;
    const [dataSource, setDataSource] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [lastFilterText, setLastFilterText] = useState('');
    const setFilterTextDebonced = useCallback(debounce((v = '') => {
        setFilterText(v);
    }, 500), []);
    const handleSearch = useCallback((v = '') => {
        setLastFilterText(v);
        const value = typeof v === 'string' ? v : '';
        const tmpCustomParams = Object.keys(params)
            .reduce((result, item) => {
            result.push(`${item}=${params[item]}`);
            return result;
        }, [])
            .join('&');
        const customParams = tmpCustomParams ? `&${tmpCustomParams}` : '';
        const hostName = getItemCenterHost(window.location);
        return getOwners(hostName, value, customParams).then((res) => {
            const { data } = res;
            const { result = [], lastActiveOptions = [] } = data;
            setDataSource([...result, ...lastActiveOptions]);
        });
    }, [params]);
    useEffect(() => {
        if (lastFilterText !== filterText) {
            handleSearch(filterText);
        }
    }, [filterText, lastFilterText, handleSearch]);
    // 初始化执行一次
    useEffect(() => {
        handleSearch();
    }, []);
    return (React.createElement(CnAsyncSelect, { placeholder: $i18n.get({ id: 'PleaseSelectTheOwner', dm: '请选择货主' }), ...props, mode: mode || 'single', showSearch: true, hasClear: true, filterLocal: false, autoWidth: false, onSearch: (v) => {
            setFilterTextDebonced(v);
        }, dataSource: dataSource }));
}
OwnerSelect.displayName = 'OwnerSelect';
export { OwnerSelect };
